import React from 'react';
import {
  InputLabel,
  Select,
  MenuItem,
  Grid,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import commons from '../../../assets/styles/commons';
import colors from '../../../assets/styles/colors';

interface Props {
  value: number;
  onChange: (value: number) => void;
  label: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      fontFamily: commons.fontFamily,
      color: colors.secondary.deepNavy,
    },
    select: {
      fontFamily: commons.fontFamily,
      color: colors.secondary.deepNavy,
      borderColor: colors.primary.orange,
    },
  }),
);

const ItemsPerPageSelect = ({ value, onChange, label }: Props) => {
  const classes = useStyles();

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <InputLabel className={classes.label} htmlFor="itemsPerPage">
          {label}
        </InputLabel>
      </Grid>
      <Grid item>
        <Select
          className={classes.select}
          variant="outlined"
          id="itemsPerPage"
          value={value}
          onChange={event => onChange(Number(event.target.value))}
        >
          <MenuItem value={10}>10 linhas</MenuItem>
          <MenuItem value={20}>20 linhas</MenuItem>
          <MenuItem value={30}>30 linhas</MenuItem>
          <MenuItem value={50}>50 linhas</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default ItemsPerPageSelect;
